import { createSelector } from 'reselect';

import { CAPS_STATES } from '../constants';

export default function createCapabilitiesSelector(appName) {
  const capabilitiesNameSpace = createSelector(
    state => state[appName] || {},
    ({ capabilities = null }) => {
      if (!capabilities) {
        console.warn(
          `Requires "createCapabilitiesReducer" to be mounted as "capabilities" on ${appName}.`,
        );
      }
      return capabilities || {};
    },
  );

  const capabilityStates = createSelector(capabilitiesNameSpace, ({ states = {} }) => states);

  const has = status => requestedCaps =>
    createSelector(capabilityStates, states =>
      Object.values(requestedCaps).reduce((accVal, cap) => accVal && states[cap] === status, true),
    );

  return {
    hasStatus: has,
    hasFinished: has(CAPS_STATES.FINISHED),
    isOngoing: has(CAPS_STATES.ONGOING),
    hasNotStarted: has(CAPS_STATES.NOT_STARTED),
    hasNotFinished: reqCaps => state =>
      has(CAPS_STATES.ONGOING)(reqCaps)(state) || has(CAPS_STATES.NOT_STARTED)(reqCaps)(state),
  };
}
